export const actions = {
  GET_SESSION: 'getSession',
  CREATE_SESSION: 'createSession',
  CLOSE_SESSION: 'closeSession',

  GET_USERS: 'getUsers',
  CREATE_USER: 'createUser',

  GET_COMPANIES: 'getCompanies',
  GET_USER_COMPANY: 'getUserCompany',
  CREATE_COMPANY: 'createCompany',
  EDIT_COMPANY: 'editCompany',
  EDIT_USER_COMPANY_DATA: 'editUserCompanyData',

  GET_GROUPS: 'getGroups',
  CREATE_GROUP: 'createGroup',
  EDIT_GROUP: 'editGroup',
  DELETE_GROUP: 'deleteGroup',

  CREATE_PERMISSION: 'createPermission',

  GET_DEVICES: 'getDevices',
  CREATE_DEVICE: 'createDevice',
  EDIT_DEVICE: 'editDevice',
  DELETE_DEVICE: 'deleteDevice',
  SET_DEVICE_ACCUMULATORS: 'setDeviceAccumulators',

  GET_ATTRIBUTES: 'getAttributes',

  UPDATE_POSITION_ATTRIBUTES: 'updatePositionAttributes',

  GET_DRIVERS: 'getDrivers',
  CREATE_DRIVER: 'createDriver',
  UPDATE_DRIVER: 'updateDriver',
  REMOVE_DRIVER: 'removeDriver',

  GET_GEO_FENCES: 'getGeoFences',
  GET_USER_GEO_FENCES: 'getUserGeoFences',
  CREATE_USER_GEO_FENCE: 'createUserGeoFences',
  UPDATE_USER_GEO_FENCE: 'updateUserGeoFences',
  DELETE_USER_GEO_FENCE: 'deleteUserGeoFences',

  GET_MAKES: 'getMakes',
  GET_MODELS: 'getModels',

  GET_VEHICLES: 'getVehicles',
  CREATE_VEHICLE: 'createVehicle',
  EDIT_VEHICLE: 'editVehicle',
  DELETE_VEHICLE: 'deleteVehicle',
  GET_VEHICLE_ODOMETER: 'getVehicleOdometer',
  SET_VEHICLE_ODOMETER: 'setVehicleOdometer',
  GET_VEHICLE_LAST_POSITION: 'getVehicleLastPosition',
  ENABLE_VEHICLE_IMMOBILIZER: 'enableVehicleImmobilizer',
  DISABLE_VEHICLE_IMMOBILIZER: 'disableVehicleImmobilizer',

  GET_VEHICLE_RECIPIENTS: 'getVehicleRecipients',
  CREATE_VEHICLE_RECIPIENT: 'createVehicleRecipient',
  EDIT_VEHICLE_RECIPIENT: 'editVehicleRecipient',
  DELETE_VEHICLE_RECIPIENT: 'deleteVehicleRecipient',

  GET_TASKS: 'getTasks',
  GET_TASK_VIEW_ONLY: 'getTaskViewOnly',
  CREATE_TASK: 'createTask',
  UPDATE_TASK: 'updateTask',
  DELETE_TASK: 'deleteTask',
  SEND_TASK_LINK: 'sendTaskLink',
  ACCEPT_TASK: 'acceptTask',
  VALIDATE_TASK: 'validateTask',
  DETECT_TASK_VEHICLE: 'detectTaskVehicle',
  SYNC_OAZIS_DAILY: 'syncOazisDaily',
  GET_OAZIS_REQUESTS: 'getOazisRequests',
  GET_TASK_SCHEDULES: 'getTaskSchedules',
  GET_TASK_SCHEDULE: 'getTaskSchedule',
  CREATE_TASK_SCHEDULE: 'createTaskSchedule',
  UPDATE_TASK_SCHEDULE: 'updateTaskSchedule',
  DELETE_TASK_SCHEDULE: 'deleteTaskSchedule',
  ACTIVATE_TASK_SCHEDULE: 'activateTaskSchedule',
  DEACTIVATE_TASK_SCHEDULE: 'deactivateTaskSchedule',

  CHECK_VEHICLE_TAXES: 'checkVehicleTaxes',
  CHECK_VIOLATIONS: 'checkViolations',

  GET_MAINTENANCES_BY_USER: 'getMaintenancesByUser',
  GET_TRACCAR_MAINTENANCES_BY_USER: 'getTraccarMaintenancesByUser',
  CREATE_MAINTENANCE_BY_DEVICE_ID: 'createMaintenanceByDeviceId',
  EDIT_MAINTENANCE: 'editMaintenance',
  DELETE_MAINTENANCE: 'deleteMaintenance',
  COMPLETE_MAINTENANCE: 'completeMaintenance',
  SHOW_MAINTENANCE_NOTIFICATIONS: 'showMaintenanceNotifications',

  GET_TRIPS_DATA: 'getTripsData',
  EXPORT_TRIPS_DATA: 'exportTripsData',
  GET_TRIPS_RECORD_POSITIONS: 'getTripsRecordPositions',
  ACCUMULATE_TRIPS_RECORD_POSITIONS: 'accumulateTripsRecordPositions',
  GET_TRIPS_RECORD_POSITIONS_WITH_STOPS: 'getTripsRecordPositionsWithStops',
  GET_TRACCAR_POSITIONS: 'getTraccarPositions',

  EVENT_RECEIVED: 'eventReceived',
  GET_EVENTS_RECORDS: 'getEventsRecords',
  GET_CURRENT_USER_ASSIGNED_EVENTS: 'getCurrentUserAssignedEvents',

  GET_ASSIGNABLE_EVENTS: 'getAssignableEvents',
  GET_USER_ASSIGNED_EVENTS: 'getUserAssignedEvents',
  SET_USER_ASSIGNED_EVENTS: 'setUserAssignedEvents',
  CLAIM_INTEREST_IN_EVENTS: 'claimInterestInEvents',

  GET_ROAD_LIST_REPORT: 'getRoadListReport',
  GET_MONTHLY_VEHICLE_REPORT: 'getMonthlyVehicleReport',
  GET_MONTHLY_COMPANY_REPORT: 'getMonthlyCompanyReport',
  GET_IMPORTANT_EVENTS_REPORTS: 'getImportantEventsReport',
  GET_ENGINE_HOURS_REPORT: 'getEngineHoursReport',
  GET_TASKS_REPORTS: 'getTasksReport',
  GET_VEHICLES_REPORT: 'getVehiclesReport',
  GET_DRIVERS_REPORT: 'getDriversReport',

  GET_NAVIGATION_DIRECTIONS: 'getNavigationDirections',
};

export const mutations = {
  SET_IS_LOADING: 'setIsLoading',
  SET_SESSION: 'setSession',
  SET_USERS: 'setUsers',
  SET_COMPANIES: 'setCompanies',
  SET_GROUPS: 'setGroups',
  APPEND_POSITIONS: 'appendPositions',
  CLEAR_POSITIONS: 'clearPositions',
  SET_DEVICES: 'setDevices',
  APPEND_DEVICES: 'appendDevices',

  SET_DRIVERS: 'setDrivers',
  SET_GEO_FENCES: 'setGeoFences',
  SET_USER_GEO_FENCES: 'setUserGeoFences',
  SET_DEVICE_DRIVER: 'setDeviceDriver',
  CLEAR_DEVICE_DRIVERS: 'setDeviceDrivers',

  SET_DEVICE_IGNITION: 'setDeviceIgnition',
  CLEAR_DEVICE_IGNITIONS: 'setDeviceIgnitions',

  SET_MAKES: 'setMakes',
  SET_MODELS: 'setModels',
  SET_VEHICLES: 'setVehicles',
  SET_VEHICLE: 'setVehicle',

  SET_VEHICLE_RECIPIENTS: 'setVehicleRecipients',

  SET_VIOLATIONS: 'setViolations',
  SET_MAINTENANCES: 'setMaintenances',
  SET_TRACCAR_MAINTENANCES: 'setTraccarMaintenances',

  SET_TRIPS_FILTER_DATE_FROM: 'setTripsFilterDateFrom',
  SET_TRIPS_FILTER_DATE_TO: 'setTripsFilterDateTo',
  SET_TRIPS_FILTER_DEVICE_ID: 'setTripsFilterDeviceId',
  SET_TRIPS_FILTER_DRIVER: 'setTripsFilterDriver',
  SET_TRIPS_FILTER_GROUP: 'setTripsFilterGroup',
  SET_TRIPS_FILTER_INCLUDE_ADDRESSES: 'setTripsFilterIncludeAddresses',
  SET_GARAGE_FILTER_DEVICE: 'setGarageFilterDevice',
  SET_GARAGE_FILTER_STATUS: 'setGarageFilterStatus',
  SET_TRIPS_DATA: 'setTripsData',
  SET_TRIPS_RECORD_POSITIONS: 'setTripRecordPositions',
  SET_TRIPS_MAP_DATA: 'setTripsMapData',
  CLEAR_TRIPS_MAP_DATA: 'clearTripsMapData',

  TOGGLE_EVENTS_PANEL: 'toggleEventsSidePanel',
  APPEND_EVENT: 'appendEvent',
  CLEAR_EVENTS: 'clearEvents',
  SET_EVENTS_FILTER_DATE_FROM: 'setEventsFilterDateFrom',
  SET_EVENTS_FILTER_DATE_TO: 'setEventsFilterDateTo',
  SET_EVENTS_FILTER_DEVICE_ID: 'setEventsFilterDeviceId',
  SET_EVENTS_FILTER_STATUSES: 'setEventsFilterStatuses',
  SET_EVENTS_RECORDS: 'setEventsRecords',
  SET_CURRENT_USER_ASSIGNED_EVENTS: 'setCurrentUserAssignedEvents',

  SET_TASKS: 'setTasks',
  SET_TASK: 'setTask',
  REMOVE_TASK: 'removeTask',
  SET_TASKS_FILTER_STATUS: 'setTasksFilterStatus',
  SET_TASKS_FILTER_DATE_FROM: 'setTasksFilterDateFrom',
  SET_TASKS_FILTER_DATE_TO: 'setTasksFilterDateTo',
  SET_TASKS_FILTER_DRIVER: 'setTasksFilterDriver',
  SET_TASKS_FILTER_VEHICLE: 'setTasksFilterVehicle',
  SET_TASKS_FILTER_TAGS: 'setTasksFilterTags',
  RESET_TASKS_FILTERS: 'resetTasksFilters',
  SET_TASK_SCHEDULES: 'setTaskSchedules',
  SET_TASK_SCHEDULE: 'setTaskSchedule',
  REMOVE_TASK_SCHEDULE: 'removeTaskSchedule',

  SET_GUEST_MODE: 'setGuestMode',
  SET_LOCALE: 'setLocale',
  SET_USE_NEW_DASHBOARD_VIEW: 'setUseNewDashboardView',
  SET_USE_DEFAULT_DASHBOARD_VIEW: 'setUseDefaultDashboardView',
};
